import { render, staticRenderFns } from "./HelpCenterAmbientBg.vue?vue&type=template&id=6b70629e&scoped=true"
import script from "./HelpCenterAmbientBg.vue?vue&type=script&lang=ts"
export * from "./HelpCenterAmbientBg.vue?vue&type=script&lang=ts"
import style0 from "./HelpCenterAmbientBg.vue?vue&type=style&index=0&id=6b70629e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b70629e",
  null
  
)

export default component.exports